// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__ylrMD","value":"Rating_value__y96Lv"};